module.exports = __webpack_public_path__ + "img/big2-4.4122823d.jpg";